export default "//file.bilionpass.com/japandx-portal/0.1.17/static/img/bilionpass-logo.0ae4ff6c-cd2d63.png";